//import moment from 'moment/moment';
import moment from 'moment-timezone';

export const parseHubSpotShortcode = (shortcode) => {
  if (!shortcode) return { portalId: null, formId: null };

  // Replace both opening and closing typographic quotes with standard quotes
  shortcode = shortcode.replace(/“|”/g, '"');

  const portalRegex = /portal="(\d+)"/;
  const idRegex = /id="([a-z0-9-]+)"/;

  const portalId = shortcode.match(portalRegex)
    ? shortcode.match(portalRegex)[1]
    : null;
  const formId = shortcode.match(idRegex) ? shortcode.match(idRegex)[1] : null;

  return { portalId, formId };
};

export const generateVimeoIframe = (
  url,
  muted = false,
  autoplay = false,
  loop = false,
  controls = true
) => {
  if (!url) return null;

  // Extract the video ID from the URL using a regular expression.
  const match = url.match(/vimeo\.com\/(video\/)?(\d+)/);
  if (!match) return null;

  const videoId = match[2];

  // Build the query string based on the options provided.
  const queryParameters = new URLSearchParams();

  if (autoplay) queryParameters.append('autoplay', '1');
  if (muted) queryParameters.append('muted', '1');
  if (loop) queryParameters.append('loop', '1');
  if (!controls) queryParameters.append('background', '1'); // Disables controls

  // Ensure do not track parameter is always present
  queryParameters.append('dnt', '1');

  return `<iframe data-muted="${muted}" data-autoplay="${autoplay}" data-loop="${loop}" data-controls="${controls}"
        src="https://player.vimeo.com/video/${videoId}?${queryParameters.toString()}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
};

export const generateVimeoIframeNonAttributes = (
  url,
  muted = false,
  autoplay = false,
  loop = false,
  controls = true
) => {
  if (!url) return null;

  // Extract the video ID from the URL using a regular expression.
  const match = url.match(/vimeo\.com\/(video\/)?(\d+)/);
  if (!match) return null;

  const videoId = match[2];

  // Build the query string based on the options provided.
  const queryParameters = new URLSearchParams();

  if (autoplay) queryParameters.append('autoplay', '1');
  if (muted) queryParameters.append('muted', '1');
  if (loop) queryParameters.append('loop', '1');
  if (!controls) queryParameters.append('background', '1'); // Disables controls

  // Ensure do not track parameter is always present
  queryParameters.append('dnt', '1');

  return `<iframe src="https://player.vimeo.com/video/${videoId}?${queryParameters.toString()}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
};

export const calculateSecondsToCount = (webinarDate) => {
  const webinarMoment = moment.tz(
    webinarDate,
    'DD/MM/YYYY HH:mm',
    themeSettings.timezone
  );
  const now = moment.tz(themeSettings.timezone);
  return Math.max(0, webinarMoment.diff(now, 'seconds'));
};

export const getTimezoneDate = (webinarDate) => {
  return moment.tz(webinarDate, 'DD/MM/YYYY HH:mm', themeSettings.timezone);
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const getCurrentPostAcfFields = () => {
  if (!window.acfFields) {
    window.acfFields = acf.getFields();
  }

  return window.acfFields;
};
